import { useEffect, useState } from 'react';

import { globalRecordingManager } from './global-recording-manager';
import VoicePill from './voice-pill';

export const GlobalVoicePillHeader = () => {
  const [state, setState] = useState(() => globalRecordingManager.getState());

  useEffect(() => {
    const unsubscribe = globalRecordingManager.subscribe(() => {
      setState({ ...globalRecordingManager.getState() });
    });
    return unsubscribe;
  }, []);

  return (
    <div
      style={{
        position: 'fixed',
        top: 8,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 6,
        pointerEvents: 'auto',
      }}
    >
      <VoicePill
        accentColor="#f5f5f5"
        iconColor="#a1a1aa"
        background="#27272a"
        size={28}
        shape="pill"
        reach={8}
        showTime
        waveform
        slideToCancel
        cancelDistance={64}
        attack={40}
        release={240}
        sensitivity={1}
        floor={0.1}
        openDuration={200}
        pressScale={0.95}
        mode="auto"
        holdAfter={300}
        reactive="simulated"
        listening={state.isRecording}
        onStart={() => {
          globalRecordingManager.startRecording().catch(console.error);
        }}
        onStop={({ reason, duration }) => {
          globalRecordingManager.stopRecording(reason, duration).catch(console.error);
        }}
      />

      {state.isTranscribing && (
        <div
          style={{
            background: 'rgba(24, 24, 27, 0.92)',
            border: '1px solid rgba(56, 189, 248, 0.4)',
            backdropFilter: 'blur(12px)',
            color: '#38bdf8',
            fontSize: 12,
            padding: '4px 12px',
            borderRadius: 999,
            boxShadow: '0 4px 12px rgba(0,0,0,0.4)',
            animation: 'pulse 1.5s infinite',
            whiteSpace: 'nowrap',
          }}
        >
          {state.statusMessage || '✨ Đang dịch âm thanh với Whisper Large V3...'}
        </div>
      )}
    </div>
  );
};

export default GlobalVoicePillHeader;
